import $ from 'jquery';
import debounce from 'debounce';

export default () => {
  const $window = $(window);
  const $logo = $('#header .logo-fadeInUp');
  const offset = +$logo
    .add('<div class="fadeInUp-offset-0">')
    .first()
    .attr('class')
    .split(/\s+/)
    .find(className => className.startsWith('fadeInUp-offset-'))
    .split('-')
    .pop();

  if (offset) {
    $window.on('scroll', debounce(function() {
      if ($window.scrollTop() > offset) {
        $logo.addClass('visible');
      } else {
        $logo.removeClass('visible');
      }
    }, 50));
  }
};
